<div class="mt-80">
    <div class="how-it-works">
        <h2 class="title">{{ title }}</h2>
        <div class="steps">
            <article class="step" *ngFor="let step of steps; let index = index; trackBy: trackByStep">
                <img [src]="step.image" [alt]="step.alt" />
                <div class="step-number">{{ index + 1 }}</div>
                <h3 class="step-title">{{ step.title }}</h3>
                <p class="step-text">{{ step.description }}</p>
            </article>
        </div>
    </div>
</div>